export default {
    validEqualDateNow(validDate) {
        let dateNow = new Date();
        const dateNowStr =
            dateNow.getFullYear() +
            "-" +
            this.prefixInteger(dateNow.getMonth() + 1, 2) +
            "-" +
            this.prefixInteger(dateNow.getDate(), 2);

        if (dateNowStr == validDate) {
            return true;
        } else {
            return false;
        }
    },
    prefixInteger(num, length) {
        return (Array(length).join("0") + num).slice(-length);
    }
}